import { render, staticRenderFns } from "./AdminRequestsTable.vue?vue&type=template&id=7e442023&scoped=true"
import script from "./AdminRequestsTable.vue?vue&type=script&lang=js"
export * from "./AdminRequestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e442023",
  null
  
)

export default component.exports